<template>
  <div>
    <!--Map Section Start-->
    <section class="p-0">
      <div class="container-fluid">
        <div class="bottom-section">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="address-bar">
                <div>
                  <ul class="footer-style">
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/locate.png"' alt="locate">
                      </div>
                      <div class="footer-address">
                        <p>SFP Publicité <br> Service Clean Touch Protect <br > 12 Zac de Cocoyer <br> 97118 Saint-François</p>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/telephone.png"' alt="telephone">
                      </div>
                      <div class="footer-address">
                        <p>Guadeloupe : <a href="tel:0690807800">0690 807 800</a> / <a href="tel:0690683868">0690 683 868</a> <br> Martinique :  <a href="tel:0696823093">0696 823 093</a></p>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/fotter-email.png"' alt="fotter-email">
                      </div>
                      <div class="footer-address">
                        <p><a href="mailto:contact@clean-touch-protect.fr">contact@clean-touch-protect.fr</a></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 p-0">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15319.83714945626!2d-61.266471!3d16.273857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x41bc704e830e5b12!2sSUN%20FRISE!5e0!3m2!1sfr!2sfr!4v1611064156790!5m2!1sfr!2sfr" class="md-height"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Map Section Ends-->
  </div>
</template>
<script>
export default {
  name: 'Map'
}
</script>
<style scoped>
@media screen and (max-width: 767px) {
  .md-height {
    height: 400px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue